export default __webpack_public_path__ + "static/Guelph-f1e1102a64d2459b0bd32c8364908fdc.png";